type Props = {
  originalText: string;
};

const useTextParser = (props: Props) => {
  const { originalText } = props;
  const formattedText = originalText.replace(/<br\/?>/g, '\n');

  return { formattedText };
};

export default useTextParser;
